import { connect } from 'react-redux'
import { sagaActions } from 'store/sagas'
import avatarSelector from './avatarSelector'
import Avatar from './Avatar'

export default connect(
  avatarSelector,
  {
    fetchUserAvatar: sagaActions.fetchUserAvatar
  },
  null,
  {
    forwardRef: true
  }
)(Avatar)
